<template>
    <v-card
            min-width="1400"
            max-width="1400"
            class="mt-2"
            elevation="0"
    >
        <v-card
            min-width="1200"
            max-width="1200"
            class="mt-1 mb-1"
            elevation="0"
        >
            <v-row>
                <v-col cols="auto">
                    <div class="font-weight-black">
                        Item Visualize Balance Graph
                    </div>
                </v-col>
                <v-col >
                    <v-select
                        v-model="selectedKey"
                        :items="keyList"
                        item-title="Key Comparison"
                        label="Key Comparison"
                        return-object
                    ></v-select>
                </v-col>
                <v-col class="mt-2">
                    <v-btn
                                @click="doImportClick()"
                        >
                            Import Json With Item Status
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        

        <ComparisonChart :chartDatas="chartDatas" />

        <v-range-slider
                v-model="levelRange"
                :max="20000"
                :min="1"
                :step="1"
                class="align-center"
                track-color="gray"
                color="red"
                hide-details
        >
            <template v-slot:prepend>
                <v-text-field
                        v-model="levelRange[0]"
                        density="compact"
                        style="width: 70px"
                        type="number"
                        variant="outlined"
                        hide-details
                        single-line
                        hint="level"
                ></v-text-field>
            </template>
            <template v-slot:append>
                <v-text-field
                        v-model="levelRange[1]"
                        density="compact"
                        style="width: 70px"
                        type="number"
                        variant="outlined"
                        hide-details
                        single-line
                ></v-text-field>
            </template>
        </v-range-slider>
        <v-container>
            <v-row align="center" justify="center">
                <v-col cols="auto">
                    <v-btn
                            @click="doApply"
                    >
                        Server Stages Load
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <SmpDialog
                    :shouldShow="isShowImportBrowser"
                    p-ignore-close
                    @close="isShowImportBrowser=false"
            >
                <ImportJsonBrowser
                        @import="onImportJson"
                        @close="isShowImportBrowser=false"/>
        </SmpDialog>
        
        <PopupMessage v-if="messageAlert!==''"
                      :pColor="messageColor"
                      :pTimeout="600"
                      @onClose="messageAlert=''"
        >
            {{messageAlert}}
        </PopupMessage>

        <v-overlay :value="isLoading">
            <v-progress-circular
                    indeterminate
                    size="64"
            ></v-progress-circular>
        </v-overlay>
    </v-card>
</template>

<script>
    import LevelSimulatorRefLoader from "./../../dao/LevelSimulatorRefLoader";
    import ComparisonChart from "./components/ComparisonChart";
    import ImportJsonBrowser from '../../../components/commons/ImportJsonBrowser';
    import SmpDialog from "@/item-editor/modules/SmpDialog";
    import PopupMessage from "@/item-editor/modules/PopupMessage/PopupMessage";

    export default {
        components: {
            ComparisonChart,
            ImportJsonBrowser,
            SmpDialog,
            PopupMessage
        },
        data() {
            return {
                levelRange: [1, 1000],
                fullData: [],
                keyList: [
                    "ghostFarming",
                    "timeToKillBoss",
                    "totalStageTime",
                    "lvHeroRemainCanBuy",
                    "heroBossFailed",
                    "heroBossFailedTimes"
                ],
                selectedKey: "ghostFarming",
                isLoading: false,
                isShowImportBrowser: false,
                json2: [],//[{"stage": 45, "ghostFarming": 10}, {"stage": 65, "ghostFarming": 25}],
                messageAlert: '',
                messageColor: 'green'
            };
        },
        methods:{
            async doApply(){
                this.isLoading = true;
                await this.loadData();
                this.isLoading = false;
            },

            async init(){
                this.isLoading = true;
                await this.loadData();
                this.initFilter();
                this.isLoading = false;
            },

            async loadData(){
                let levelStart = parseInt(this.levelRange[0]);
                let levelEnd = parseInt(this.levelRange[1]);
                this.fullData = await LevelSimulatorRefLoader.loadAutoplayStateByRange(levelStart, levelEnd);
            },

            initFilter(){
                this.selectedKey = "ghostFarming";
            },

            doImportClick() {
                this.isShowImportBrowser = true;
            },
            onImportJson(json){
                this.isShowImportBrowser = false;
                if(json !== ''){
                    this.json2 = json.automateGameStateList;
                } else {
                    this.json2 = [];
                    this.setAlertMessage('Import failed!', true);
                }
            },
            setAlertMessage(msg, isError){
                this.messageAlert = msg;
                if(isError){
                    this.messageColor = "red";
                } else {
                    this.messageColor = "success";
                }
            },
            getValueFromKey(item, key){
                if(Array.isArray(item[key])){
                    return this.average(item[key]);
                } else {
                    return item[key];
                }
            },
            average(numsAray) {
              if (numsAray.length === 0) return 0;
              const sum = numsAray.reduce((acc, val) => acc + val, 0);
              return (sum / numsAray.length).toFixed(2); // rounded to 2 decimals
            }
        },
        computed: {
            json1(){
                return this.fullData;
            },

            chartDatas(){
                let labels = undefined;

                const datasets = [];
                datasets.push({
                  label: "Without Item",
                  //data: this.json1.map(item => item[this.selectedKey]),
                  borderColor: "rgba(255, 99, 132, 1)",
                  backgroundColor: "rgba(255, 99, 132, 0.2)",
                  fill: false,
                  tension: 0.1
                });

                let isUseAllStage = true;

                if(this.json1.length > 0){
                    let startStage = this.json1[0].stage;
                    let isJson2Exist = this.json2 && this.json2.length > 0;
                    if(isJson2Exist){
                        let statgeCompare = [];
                        const compareJson2 = this.json2.filter((js) => {
                            if(js.stage >= startStage){
                                statgeCompare.push(js.stage);
                                return true;
                            } else {
                                return false;
                            }
                        });
                        

                        if(statgeCompare.length > 0){
                            datasets.push({
                              label: "With Item",
                              data: compareJson2.map(item => this.getValueFromKey(item, this.selectedKey)),
                              borderColor: "rgba(54, 162, 235, 1)",
                              backgroundColor: "rgba(54, 162, 235, 0.2)",
                              fill: false,
                              tension: 0.1
                            });

                            let compareJson1 = this.json1.filter((js) => statgeCompare.includes(js.stage));
                            datasets[0].data = compareJson1.map(item => this.getValueFromKey(item, this.selectedKey));
                            labels = compareJson1.map(item => item.stage);
                            isUseAllStage = false;
                        }
                    }
                }

                if(isUseAllStage){
                    datasets[0].data = this.json1.map(item => item[this.selectedKey]);
                    labels = this.json1.map(item => item.stage);
                }

                return {
                            labels: labels,
                            datasets: datasets//[dataset1, dataset2, dataset3]
                };
            }
        },
        created() {
            this.init();
        }
    };
</script>